import { Checkbox } from '@cian/ui-kit';
import * as React from 'react';
import { AutoprolongHintContainer } from '../../../AutoprolongHint';
import * as styles from './Autoprolong.css';

interface IAutoprolongProps {
  autoProlong: boolean;
  onChange(e: React.ChangeEvent, value: boolean): void;
}

export const Autoprolong = (props: IAutoprolongProps) => {
  const { autoProlong, onChange } = props;

  return (
    <div className={styles['autoprolong']}>
      <Checkbox label="Автопродление" checked={autoProlong} onChange={onChange} />

      <div className={styles['autoprolong_hint']}>
        <AutoprolongHintContainer />
      </div>
    </div>
  );
};
